<template>
  <v-container>
    <v-row>
      <v-col cols="11">
        <h1>Gestion de vos demandes</h1>
      </v-col>
      <v-col>
        <v-tooltip bottom color="produit">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mb-2"
              fab
              dark
              color="produit"
              v-bind="attrs"
              v-on="on"
              :to="{ name: 'demande' }"
            >
              <v-icon dark> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Créer une demande</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <demandes-liste></demandes-liste>
  </v-container>
</template>

<script>
import DemandesListe from "@/components/DemandesListe";
import FournisseurService from "@/services/FournisseurService";

export default {
  components: {
    DemandesListe,
  },
  beforeRouteEnter(to, from, next) {
    Promise.allSettled([
      FournisseurService.getDemandes({ etat: 1 }).catch((err) => {
        if (err.response.status == 404) {
          // err.response.headers["x-total-count"] = 0;
          return { data: [] };
        }
      }),
      FournisseurService.getEtatsDemandes(),
      FournisseurService.getProduitsDemandes(),
      FournisseurService.getDemandesIds(),
    ])
      .then((res) => {
        let demandes = [];
        let etats = [];
        let totalDemandes = 0;
        let produits = [];
        let ids = [];

        if (res[0].status == "fulfilled") {
          demandes = res[0].value.data;
          totalDemandes = res[0].value.headers
            ? parseInt(res[0].value.headers["x-total-count"])
            : 0;
        }
        if (res[1].status == "fulfilled") {
          etats = res[1].value.data;
        }

        if (res[2].status == "fulfilled") {
          produits = res[2].value.data;
        }

        if (res[3].status == "fulfilled") {
          ids = res[3].value.data;
        }
        next((vm) => {
          vm.$store.dispatch("demandes/setPageDemandes", {
            demandes,
            totalDemandes,
          });
          vm.$store.dispatch("demandes/setEtats", etats);
          vm.$store.dispatch("demandes/setProduits", produits);
          vm.$store.dispatch("demandes/setIds", ids);
        });
      })
      .catch((err) => {
        if (err.response && err.response.status && err.response.status == 401) {
          next({ name: "home" });
        } else if (
          err.response &&
          err.response.status &&
          err.response.status == 404
        ) {
          next();
        } else if (err instanceof Error) {
          let errorToPropagate = new Error();
          errorToPropagate.originalError = err;
          next(errorToPropagate);
        }
      });
  },
};
</script>

<style></style>
